import { Outlet, useLocation } from "react-router-dom";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import DonkeyBotLauncher from "@/components/DonkeyBotLauncher";

// Focused authenticated product screens stay uncluttered (no marketing footer).
const NO_FOOTER = ["/dashboard", "/workspace", "/admin", "/validate"];

export default function Layout() {
  const { pathname } = useLocation();
  const hideFooter = NO_FOOTER.some((p) => pathname === p || pathname.startsWith(p + "/"));
  return (
    <div className="min-h-screen flex flex-col bg-donkey-bg">
      <Navbar />
      <main className="flex-1">
        <Outlet />
      </main>
      {!hideFooter && <Footer />}
      <DonkeyBotLauncher />
    </div>
  );
}
